import { useLanguage } from '../../../hooks/useLanguage';

export default function ProblemNew() {
  const { language } = useLanguage();

  const content = {
    de: {
      label: 'Die Herausforderung',
      headline: 'Telcos verlieren täglich Geld durch manuelle Prozesse',
      subtext: 'Während Ihre Mitarbeiter Tickets sortieren, Rechnungen prüfen und Anfragen weiterleiten, wächst der Kostendruck — und die Konkurrenz automatisiert.',
      problems: [
        {
          icon: 'ri-time-line',
          title: 'Langsame Ticketbearbeitung',
          description: 'Support-Teams verbringen Stunden mit Routing und Kategorisierung statt mit Lösungen.'
        },
        {
          icon: 'ri-error-warning-line',
          title: 'Fehleranfällige Prozesse',
          description: 'Manuelle Rechnungsprüfung und Dateneingabe führen zu Verzögerungen und Fehlern.'
        },
        {
          icon: 'ri-team-line',
          title: 'Überlastete Teams',
          description: 'Repetitive Aufgaben binden Ressourcen, die für strategische Projekte fehlen.'
        },
        {
          icon: 'ri-line-chart-line',
          title: 'Steigende OPEX',
          description: 'Jeder manuelle Schritt kostet Geld — und skaliert nicht mit dem Geschäft.'
        }
      ]
    },
    en: {
      label: 'The Challenge',
      headline: 'Telcos lose money daily through manual processes',
      subtext: 'While your employees sort tickets, check invoices, and forward requests, cost pressure grows — and competitors automate.',
      problems: [
        {
          icon: 'ri-time-line',
          title: 'Slow Ticket Processing',
          description: 'Support teams spend hours on routing and categorization instead of solutions.'
        },
        {
          icon: 'ri-error-warning-line',
          title: 'Error-Prone Processes',
          description: 'Manual invoice checking and data entry lead to delays and errors.'
        },
        {
          icon: 'ri-team-line',
          title: 'Overloaded Teams',
          description: 'Repetitive tasks tie up resources needed for strategic projects.'
        },
        {
          icon: 'ri-line-chart-line',
          title: 'Rising OPEX',
          description: 'Every manual step costs money — and doesn\'t scale with the business.'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section id="problem" className="relative py-20 sm:py-28 bg-black">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 fade-in-section">
          <div className="inline-block px-3 py-1 bg-red-500/10 border border-red-500/30 rounded-full mb-4">
            <span className="text-red-400 text-xs font-semibold uppercase tracking-widest">{t.label}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
            {t.headline}
          </h2>
          <p className="text-base sm:text-lg text-white/60 max-w-2xl mx-auto leading-relaxed">
            {t.subtext}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {t.problems.map((problem, i) => (
            <div
              key={i}
              className="fade-in-section bg-white/5 border border-white/10 rounded-xl p-6 sm:p-8 hover:border-red-500/40 transition-all group"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-500/10 rounded-lg mb-4 group-hover:bg-red-500/20 transition-all">
                <i className={`${problem.icon} text-2xl text-red-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{problem.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}